<!-- Container for the keycloak login form, user is not logged in -->

@if (!loggedIn) {
  <customer-portal-app-login-view></customer-portal-app-login-view>
}

<!-- User logged in -->
@if (loggedIn) {
  @if (!showTransifexSpinner) {
    <router-outlet></router-outlet>
  }
  @if (kcUpdateIframeSrc) {
    <ng-container class="kc-update-iframe">
      <iframe
        #kcupdateframe
        [src]="kcUpdateIframeSrc"
        (load)="kcUpdateIframeLoaded()"
        title="kc update iframe"
      ></iframe>
    </ng-container>
  }
  <!--Size detector-->
  <customer-portal-app-size-detector></customer-portal-app-size-detector>
  <customer-portal-pwa-detector></customer-portal-pwa-detector>
  <customer-portal-app-bottom-navbar></customer-portal-app-bottom-navbar>
  <!-- IOS add to home screen -->
  @if (isIos && !isPwa && showIosAddHomeScreenBanner && pwaEnabled) {
    <customer-portal-ios-add-homescreen-banner
      class="h-screen w-screen absolute top-0"
      (bannerDismiss)="hideIosAddHomeScreenBanner()"
    ></customer-portal-ios-add-homescreen-banner>
  }
}

<customer-portal-lib-cpt-templates></customer-portal-lib-cpt-templates>

@if (showTransifexSpinner) {
  <customer-portal-ef-spinner-dialog
  ></customer-portal-ef-spinner-dialog>
}
